import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"height":"50px","width":"100px"} }
const _hoisted_2 = { class: "text-h5" }
const _hoisted_3 = { class: "mx-auto text-center" }
const _hoisted_4 = { class: "text-h5" }
const _hoisted_5 = { class: "text-caption mt-1" }
const _hoisted_6 = { class: "d-flex justify-space-between align-center pa-3 pb-2" }
const _hoisted_7 = {
  style: {"max-width":"300px"},
  class: "pa-2"
}

import {useRoute, useRouter} from "vue-router";
import {ref, watch} from "vue";
import Logo from "@/components/visual/Logo.vue";
import {APP_NAME, getColorFromName, getInitials, useGlobalSetting} from "@/lib/utils";
import {useAuth} from "@/lib/useAuth";

interface NavItem {
  id: string;
  title: string;
  icon?: string;
  /** Small overlay icon displayed as badge on top of the folder icon */
  badgeIcon?: string;
  to?: string;
  tooltip?: string;
  children?: NavItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const sidebarOpen = ref<boolean>(false);
const globalStore = useGlobalSetting();

const openedNodes = ref<string[]>([]);
const activatedNodes = ref<string[]>([]);

const {user} = useAuth();

const navigationItems: NavItem[] = [
  {
    id: 'home',
    title: 'Home',
    icon: 'mdi-home',
    to: '/home',
    tooltip: 'Zur Startseite'
  },
  {
    id: 'motorenliste',
    title: 'Motorenliste',
    icon: 'mdi-engine',
    to: '/motorenliste',
    tooltip: 'Motorenverwaltung'
  },
  {
    id: 'orders',
    title: 'Aufträge',
    icon: 'mdi-folder',
    badgeIcon: 'mdi-file-document-multiple',
    tooltip: 'Auftragsverwaltung',
    children: [
      {
        id: 'orders-all',
        title: 'Alle Aufträge',
        icon: 'mdi-file-document-multiple',
        to: '/orders',
        tooltip: 'Alle Aufträge anzeigen'
      },
      {
        id: 'orders-progress',
        title: 'In Bearbeitung',
        icon: 'mdi-file-edit',
        to: '/orders/progress',
        tooltip: 'Aufträge in Bearbeitung'
      },
      {
        id: 'orders-finished',
        title: 'Abgeschlossen',
        icon: 'mdi-file-check',
        to: '/orders/finished',
        tooltip: 'Abgeschlossene Aufträge'
      },
      {
        id: 'orders-failed',
        title: 'Unerledigt Beendet',
        icon: 'mdi-message-alert',
        to: '/orders/failed',
        tooltip: 'Unerledigt beendete Aufträge'
      }
    ]
  },
  {
    id: 'aufgaben',
    title: 'Aufgaben',
    icon: 'mdi-folder',
    badgeIcon: 'mdi-clipboard-list',
    tooltip: 'Aufgabenverwaltung',
    children: [
      {
        id: 'tasks-all',
        title: 'Alle Aufgaben',
        icon: 'mdi-clipboard-list',
        to: '/tasks',
        tooltip: 'Alle Aufgaben anzeigen'
      },
      {
        id: 'tasks-mine',
        title: 'Meine Aufgaben',
        icon: 'mdi-clipboard-account',
        to: '/tasks/mine',
        tooltip: 'Meine zugewiesenen Aufgaben'
      },
      {
        id: 'tasks-overdue',
        title: 'Überfällige',
        icon: 'mdi-clipboard-alert',
        to: '/tasks/overdue',
        tooltip: 'Überfällige Aufgaben'
      }
    ]
  },
  {
    id: 'lockouts',
    title: 'Freischaltungen',
    icon: 'mdi-folder',
    badgeIcon: 'mdi-lightning-bolt',
    tooltip: 'Freischaltaufgaben',
    children: [
      {
        id: 'lockouts-all',
        title: 'Alle Freischaltungen',
        icon: 'mdi-home-lightning-bolt-outline',
        to: '/lockouts',
        tooltip: 'Alle Freischaltungen anzeigen'
      },
      {
        id: 'lockouts-mine',
        title: 'Meine Freischaltungen',
        icon: 'mdi-lightning-bolt',
        to: '/lockouts/mine',
        tooltip: 'Meine zugewiesenen Freischaltungen'
      }
    ]
  },
  /*{
    id: 'reporting',
    title: 'Reporting',
    icon: 'mdi-folder',
    tooltip: 'Berichte und Auswertungen',
    children: [
      {
        id: 'reporting-overview',
        title: 'Übersicht',
        icon: 'mdi-view-dashboard',
        to: '/reporting',
        tooltip: 'Reporting-Übersicht'
      },
      {
        id: 'reporting-orders',
        title: 'Auftragsbericht',
        icon: 'mdi-chart-box',
        to: '/reporting/orders',
        tooltip: 'Detaillierter Auftragsbericht'
      },
      {
        id: 'reporting-tasks',
        title: 'Aufgabenbericht',
        icon: 'mdi-chart-timeline',
        to: '/reporting/tasks',
        tooltip: 'Detaillierter Aufgabenbericht'
      },
      {
        id: 'reporting-freischaltungen',
        title: 'Freischaltbericht',
        icon: 'mdi-chart-line',
        to: '/reporting/freischaltungen',
        tooltip: 'Freischaltberichte anzeigen'
      }
    ]
  },*/
      {
    id: 'recourses',
    title: 'Ressourcen',
    icon: 'mdi-timetable',
    badgeIcon: 'mdi-timetable',
    tooltip: 'Planung und Übersicht von Ressourcen',
    children: [
      {
        id: 'staff_scheduling',
        title: 'Personalplanung',
        icon: 'mdi-timetable',
        to: '/staffScheduling',
        tooltip: 'Personalplanung anzeigen'
      },
    ]
  },
  {
    id: 'checklists',
    title: 'Checklisten',
    icon: 'mdi-folder',
    badgeIcon: 'mdi-playlist-edit',
    tooltip: 'Checklisten-Verwaltung',
    children: [
      {
        id: 'checklists-templates',
        title: 'Vorlagen',
        icon: 'mdi-playlist-edit',
        to: '/checklists/templates',
        tooltip: 'Checklisten-Vorlagen verwalten'
      },
      {
        id: 'checklists-all',
        title: 'Alle',
        icon: 'mdi-list-status',
        to: '/checklists/all',
        tooltip: 'Alle Checklisten ansehen'
      },
      {
        id: 'checklists-mine',
        title: 'Meine',
        icon: 'mdi-list-status',
        to: '/checklists/mine',
        tooltip: 'Meine Checklisten ansehen'
      }
    ]
  },
  {
    id: 'outages',
    title: 'Stillstände',
    icon: 'mdi-folder',
    badgeIcon: 'mdi-power',
    tooltip: 'Berichte und Auswertungen',
    children: [
      {
        id: 'outages-overview',
        title: 'Übersicht',
        icon: 'mdi-power',
        to: '/outages',
        tooltip: 'Stillstands Übersicht'
      },
    ]
  }
];

// Icon basierend auf Item-Typ und Zustand
const getIcon = (item: NavItem, isOpen: boolean): string => {
  if (!item.children) {
    return item.icon || 'mdi-file-document-outline';
  }
  return isOpen ? 'mdi-folder-open' : 'mdi-folder';
};

// Finde das NavItem basierend auf der ID
const findItemById = (items: NavItem[], id: string): NavItem | undefined => {
  for (const item of items) {
    if (item.id === id) return item;
    if (item.children) {
      const found = findItemById(item.children, id);
      if (found) return found;
    }
  }
  return undefined;
};

// Handle activation (Click auf TreeView Item)
const handleActivation = (ids: string[]) => {
  if (ids.length > 0) {
    const item = findItemById(navigationItems, ids[0]);
    if (item?.to) {
      navigateTo(item.to);
    }
  }
};

// Setze aktiven Node basierend auf aktueller Route
watch(() => route.path, (newPath) => {
  const findByPath = (items: NavItem[]): string | undefined => {
    for (const item of items) {
      if (item.to === newPath) return item.id;
      if (item.children) {
        const found = findByPath(item.children);
        if (found) return found;
      }
    }
    return undefined;
  };

  const activeId = findByPath(navigationItems);
  if (activeId) {
    activatedNodes.value = [activeId];
  }
}, {immediate: true});

const navigateTo = (path: string) => {
  router.push(path);
  sidebarOpen.value = false;
};

function goTo(path: string) {
  router.push(path);
}



return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_treeview = _resolveComponent("v-treeview")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      app: "",
      color: "primary",
      dark: "",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = !sidebarOpen.value))
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(Logo, {
            loading: false,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/home')))
          })
        ]),
        _createVNode(_component_v_toolbar_title, { class: "text-left" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(APP_NAME)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          icon: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('/home')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("mdi-home")
              ])),
              _: 1,
              __: [10]
            })
          ]),
          _: 1
        }),
        (_unref(user))
          ? (_openBlock(), _createBlock(_component_v_menu, {
              key: 0,
              "min-width": "200px"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      color: _unref(getColorFromName)(_unref(user).user_metadata.username),
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getInitials)(_unref(user).user_metadata.username)), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_avatar, {
                            color: _unref(getColorFromName)(_unref(user).user_metadata.username)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getInitials)(_unref(user).user_metadata.username)), 1)
                            ]),
                            _: 1
                          }, 8, ["color"]),
                          _createElementVNode("h3", null, _toDisplayString(_unref(user).user_metadata.username), 1),
                          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(user).email), 1),
                          _createVNode(_component_v_divider, { class: "my-3" }),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            rounded: "",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo('/account')))
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode(" Profil ")
                            ])),
                            _: 1,
                            __: [11]
                          }),
                          _createVNode(_component_v_divider, { class: "my-3" }),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            rounded: "",
                            onClick: _unref(useAuth)().signOut
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" Abmelden ")
                            ])),
                            _: 1,
                            __: [12]
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goTo('/login'))),
              variant: "outlined",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-login")
                  ])),
                  _: 1,
                  __: [13]
                }),
                _cache[14] || (_cache[14] = _createTextVNode(" Anmelden "))
              ]),
              _: 1,
              __: [14]
            })),
        _createVNode(_component_v_btn, {
          icon: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (goTo('/settings')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("mdi-cog")
              ])),
              _: 1,
              __: [15]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: sidebarOpen.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((sidebarOpen).value = $event)),
      app: "",
      temporary: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-medium" }, "Navigation", -1)),
          _createVNode(_component_v_btn, {
            icon: "",
            size: "small",
            variant: "text",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (sidebarOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("mdi-close")
                ])),
                _: 1,
                __: [16]
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_treeview, {
            opened: openedNodes.value,
            "onUpdate:opened": _cache[7] || (_cache[7] = ($event: any) => ((openedNodes).value = $event)),
            activated: activatedNodes.value,
            "onUpdate:activated": [
              _cache[8] || (_cache[8] = ($event: any) => ((activatedNodes).value = $event)),
              handleActivation
            ],
            items: navigationItems,
            density: "compact",
            "item-value": "id",
            "item-title": "title",
            activatable: "",
            "open-on-click": "",
            "indent-lines": "",
            "separate-roots": ""
          }, {
            prepend: _withCtx(({ item, isOpen }) => [
              _createVNode(_component_v_tooltip, {
                location: "right",
                disabled: !item.tooltip,
                "open-delay": 500
              }, {
                activator: _withCtx(({ props }) => [
                  (item.badgeIcon && item.children)
                    ? (_openBlock(), _createElementBlock("span", _mergeProps({ key: 0 }, props, { class: "composite-icon" }), [
                        _createVNode(_component_v_icon, {
                          icon: isOpen ? 'mdi-folder-open' : 'mdi-folder',
                          size: "20"
                        }, null, 8, ["icon"]),
                        _createVNode(_component_v_icon, {
                          icon: item.badgeIcon,
                          size: "13",
                          class: "composite-icon__badge"
                        }, null, 8, ["icon"])
                      ], 16))
                    : (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 1 }, props, {
                        icon: getIcon(item, isOpen),
                        size: "20"
                      }), null, 16, ["icon"]))
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.tooltip), 1)
                ]),
                _: 2
              }, 1032, ["disabled"])
            ]),
            title: _withCtx(({ item }) => [
              _createVNode(_component_v_tooltip, {
                location: "right",
                disabled: !item.tooltip,
                "open-delay": 500
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("span", _mergeProps(props, {
                    class: [{ 'font-weight-bold': item.children }, "item-title"]
                  }), _toDisplayString(item.title), 17)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.tooltip), 1)
                ]),
                _: 2
              }, 1032, ["disabled"])
            ]),
            _: 1
          }, 8, ["opened", "activated"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})